export default class WysiwygSanitizer {
    constructor() {
        this.sanitize()
    }

    sanitize() {
        const wysiwygContents = document.querySelectorAll('.sanitize-wysiwyg')
        wysiwygContents.forEach((el) => {

            // remove all empty p tags
            el.innerHTML = el.innerHTML.replace(/<p>&nbsp;<\/p>/g, '')
            el.innerHTML = el.innerHTML.replace(/<p><\/p>/g, '');
            el.innerHTML = el.innerHTML.replace(/<p[^>]*>&nbsp;<\/p>/g, '');

            // remove all inline styles on p, span, blockquote, ul, li, strong and em tags
            el.innerHTML = el.innerHTML.replace(/<p[^>]*>/g, '<p>');
            el.innerHTML = el.innerHTML.replace(/<span[^>]*>/g, '<span>');
            el.innerHTML = el.innerHTML.replace(/<blockquote[^>]*>/g, '<blockquote>');
            el.innerHTML = el.innerHTML.replace(/<ul[^>]*>/g, '<ul>');
            el.innerHTML = el.innerHTML.replace(/<li[^>]*>/g, '<li>');
            el.innerHTML = el.innerHTML.replace(/<strong[^>]*>/g, '<strong>');
            el.innerHTML = el.innerHTML.replace(/<em[^>]*>/g, '<em>');

            // For a tags remove all styles and classes but keep the href and target attributes
            el.innerHTML = el.innerHTML.replace(/<a[^>]*href="([^"]*)"[^>]*>/g, '<a href="$1" target="_blank">');

            // remove special characters like &nbsp; and &amp; and &gt; and &lt;
            if (!el.classList.contains('sanitize-wysiwyg--keep-nbsp')) {
                el.innerHTML = el.innerHTML.replace(/&nbsp;/g, ' ');
            }
            el.innerHTML = el.innerHTML.replace(/&amp;/g, '&');
            el.innerHTML = el.innerHTML.replace(/&gt;/g, '>');
            el.innerHTML = el.innerHTML.replace(/&lt;/g, '<');
            el.innerHTML = el.innerHTML.replace(/&hellip;/g, '...');
        })
    }

}
